<script setup lang="ts">
/**
 * Root component. The chrome (app bar, groups sidebar, DM overlay) lives in
 * `layouts/AppLayout.vue`, which wraps every authenticated route. Unauthenticated
 * routes (login / register / pending) render bare here. All navigation state is
 * driven by the stores + router, so this component stays glue-only.
 */
</script>

<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style>
/*
 * Global dark-theme text fixes. Vuetify derives `on-surface` from `surface`,
 * but list items, menu items and subheaders inside v-card/v-menu contexts can
 * fall back to the default (near-black) text color when no explicit variant is
 * set — which is unreadable on the dark surface. Pin them to the theme
 * foreground so dropdowns, member lists and context menus stay legible.
 */
.v-list-item-title,
.v-list-item-subtitle,
.v-list-subheader,
.v-menu .v-card,
.v-list {
  color: rgb(var(--v-theme-on-surface));
}

/* Chips' tonal variant can also pick up low-contrast text on dark surfaces. */
.v-chip {
  color: rgb(var(--v-theme-on-surface));
}
</style>
